import React from 'react';

const MenuItem = ({
  label,
  icon,
  isActive,
  onClick,
  badge = null
}) => {
  return (
    <button
      className={`w-full text-left px-4 py-3 text-sm font-medium transition-colors border-l-4 ${
        isActive
          ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-300'
          : 'border-transparent hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300'
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          {icon}
          <span>{label}</span>
        </div>
        {badge}
      </div>
    </button>
  );
};

export default MenuItem;